import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFormDetails } from "../../../../apis";
import { formStarter } from "../../../JSONForms/PreviewForm/formStarter";
import { GeneralIconHeader } from "../../../Title/GeneralHeader";
import { ReportHeader2 } from "../../../Title/ReportHeader2";
import { Box } from "@mui/material";
import { AdvisorReview } from "./AdvisorReview";
import { Loading } from "../../../Loading/String/Loading";
import { PreviewForm } from "../../../JSONForms/PreviewForm/PreviewForm";
import { ReportHeader } from "../../../Title/ReportHeader";

export const ReportEdit = ({ reportDetail, assignedUsers, setEditReport }) => {
  const [t] = useTranslation("report");
  // General Report Editing
  const [steps, setSteps] = useState(null);
  const [schemaState, setSchemaState] = useState(null);
  const [formData, setFormData] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [constraints, setConstraints] = useState([]);
  const [isLoadingForm, setIsLoadingForm] = useState(true);

  const [showAdvisorReview, setShowAdvisorReview] = useState(false);

  useEffect(() => {
    initializeForm();
  }, []);

  const initializeForm = () => {
    setIsLoadingForm(true);
    getFormDetails(reportDetail?.form_id)
      .then((formLoaded) => {
        formStarter(formLoaded, "answered", reportDetail).then(
          ({
            initSteps,
            initSchemaState,
            initFormData,
            initIsValid,
            initConstraints,
          }) => {
            setSteps(initSteps);
            setSchemaState(initSchemaState);
            setFormData(initFormData);
            setIsValid(initIsValid);
            setConstraints(initConstraints);
            setIsLoadingForm(false);
          }
        );
      })
      .catch(console.error);
  };

  return (
    <div className="all-reports-page page">
      <ReportHeader
        icon="outline_edit"
        title={t("ReportsList.modify_report")}
        reportDetail={reportDetail}
        edit
      />

      <ReportHeader2
        reportDetail={reportDetail}
        assignedUsers={assignedUsers.users}
        showAssignedUsers={false}
        showIndicators={false}
        showIsAnonymous={false}
        showTrackingCode={false}
        buttons={[
          {
            type: "button",
            icon: "outline_edit_comments",
            label: showAdvisorReview
              ? t("ReportViewer.form")
              : t("ReportViewer.comments"),
            onClick: () => setShowAdvisorReview((current) => !current),
          },
          {
            tooltip: t("ReportViewer.exit"),
            type: "icon-button",
            icon: "bold_logout",
            onClick: () => setEditReport(false),
          },
        ]}
      />

      {showAdvisorReview ? (
        <Box className="dyTheme1 dyBorder1 rounded" p={1} mt={2}>
          <AdvisorReview report_id={reportDetail?.id} edit />
        </Box>
      ) : (
        <Box mt={2}>
          {isLoadingForm ? (
            <Box className="dyTheme1 dyBorder1 rounded" p={1}>
              <Loading />
            </Box>
          ) : (
            <PreviewForm
              steps={steps}
              schemaState={schemaState}
              setSchemaState={setSchemaState}
              formData={formData}
              setFormData={setFormData}
              isValid={isValid}
              setIsValid={setIsValid}
              constraints={constraints}
              setConstraints={setConstraints}
              showButtons={true}
              stepClick={false}
              answered={true}
              id={reportDetail?.id}
            />
          )}
        </Box>
      )}
    </div>
  );
};
